import type { TravelerNew, TravelerPrice, BrandedFare } from '@eti/schema-types';
import { getTravelerPrices } from '../../../utils/travelers';
import BrandedFaresV1 from './v1/BrandedFares';
import BrandedFaresV2 from './v2/BrandedFares';
import BrandedFaresV3 from './v3/branded-fares/BrandedFares';

export const getInitialBrandedFareSelectionKey =
  (brandedFares: BrandedFare[], selectionKey: string) => () => {
    if (!brandedFares?.length) {
      return null;
    }
    if (brandedFares.some((brandedFare) => brandedFare.selectionKey === selectionKey)) {
      return selectionKey;
    }
    return brandedFares[0].selectionKey;
  };

export const getBrandedFaresComponent = (brandedFaresVersion: number) => {
  switch (brandedFaresVersion) {
    case 3:
      return BrandedFaresV3;
    case 2:
      return BrandedFaresV2;
    default:
      return BrandedFaresV1;
  }
};

export const getSelectedTripPricePerAdult = (
  tripTravelers: TravelerNew[],
  travelerPrices: TravelerPrice[],
) => {
  const adultTravelerArray = tripTravelers?.[0] ? [{ ...tripTravelers?.[0] }] : [];

  const selectedTripPriceArray = getTravelerPrices(adultTravelerArray, travelerPrices);
  return selectedTripPriceArray?.[0]?.totalPrice;
};
